import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { WINDOW } from '../tokens/window';
import { environment } from '../environments/environment';

type WindowWithDataLayer = Window & { dataLayer: Record<string, unknown>[]; };

@Injectable({ providedIn: 'root' })
export class GtmService {
  private isLoaded = false;

  constructor(
    @Inject(WINDOW) private readonly window: WindowWithDataLayer,
    @Inject(DOCUMENT) private readonly document: Document,
  ) {
    this.addGtmToDom();
  }

  getDataLayer(): Record<string, unknown>[] {
    this.window.dataLayer = this.window.dataLayer || [];
    return this.window.dataLayer;
  }

  pushTag(event: string, dataObject: Record<string, unknown>): void {
    this.pushOnDataLayer({ event, ...dataObject });
  }

  private pushOnDataLayer(dataObject: Record<string, unknown>): void {
    const dataLayer = this.getDataLayer();
    dataLayer.push(dataObject);
  }

  private addGtmToDom(): void {
    if (this.isLoaded) {
      return;
    }
    this.pushOnDataLayer({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });
    const gtmScript = this.document.createElement('script');
    gtmScript.id = 'GTMscript';
    gtmScript.async = true;
    gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${environment.tagManager}`;
    this.document.head.insertBefore(gtmScript, this.document.head.firstChild);
    this.isLoaded = true;
  }
}
